import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { masterInstance as axiosmaster } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getPaymentLinkList = async (data) => {
    return decryptData(
        await axios.get(
            `/getPaymentLinkList?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};
export const checkForExistingCoupon = async (data) => {
    return decryptData(
        await axios.get(
            `/checkForExistingCoupon?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const SendPaymentLinkAdd = async (data) => {
    return decryptData(
        await axios.post(`/SendPaymentLink`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const SendPaymentLinkAddNew = async (data) => {
    return decryptData(
        await axios.post(`/SendPaymentLinkNew`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const getAmountByCourseID = async (data) => {
    return decryptData(
        await axios.get(
            `/getAmountByCourseID?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const PaymentLinkGeStudentDetails = async (data) => {
    return decryptData(
        await axiosmaster.get(
            `/payment-link-get-student-details?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};